<div class="productPlaceSection" infinite-scroll [infiniteScrollDistance]="0.1" [infiniteScrollDisabled]="entredapi"
    [scrollWindow]="true" (scrolled)="onScrollDown()" [ngStyle]="{'background-color':settingsData?.merchandise_bg_secondary_color}">
    <!-- <div class="pl-25"> <span class="d-inline-block back-class pointer" routerLink="/network-market/market"><span><i
                        class="fa fa-arrow-left" aria-hidden="true"></i></span><span>Back</span></span></div> -->
    <div class="card-Sec">
        <div class="cards-con p-0">
            <ng-container>
                <div class="cards" [ngStyle]="{'background-color':settingsData?.merchandise_card_bg_color, 'color':settingsData?.merchandise_card_font_color}">
                    <div class="imagediv" [ngStyle]="{'background-image':' url(' + imageOfBanner+ ')'}">
                        <div class="pro-img" [ngStyle]="{'background-image':' url(' + imageOfBanner+ ')','background-color':settingsData?.merchandise_bg_primary_color}">
                        </div>
                    </div>
                    <div class="desc-con" [ngStyle]="{'background-color':settingsData?.merchandise_bg_secondary_color, 'color':settingsData?.merchandise_font_secondary_color}">
                        <div class="text-center pt-60">
                            <p class="desc-h">
                                {{bannerTitle}}
                            </p>
                            <div class="dec">
                                {{descriptionOfBanner}}
                            </div>

                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="">
        <div id="changes" class="headerhide"></div>
        <div class="stickey filtersection mt-3" [ngStyle]="{'background-color':settingsData?.merchandise_bg_main_color}">
            <div class="row no-gutters align-items-center ">
                <div class="col-6 d-flex align-items-center">
                    <span class="fillter-btn mr-10 pointer fs-24" (click) = "goBack()" id="DD" [ngStyle]="{'background-color': settingsData?.merchandise_bg_primary_color , 'color': settingsData?.merchandise_font_primary_color}">
                        <span class="align-middle">
                            <i class="fa fa-angle-left" [ngStyle]="{'color': settingsData?.merchandise_font_primary_color}"></i>
                        </span>
                    </span>
                    <div class="s-con">
                        <input type="text" class="s-input" [(ngModel)]="query"
                            [ngStyle]="{'background-color': settingsData?.merchandise_bg_primary_color , 'color': settingsData?.merchandise_font_primary_color}"
                            [style]="'--placeholder-color:' + settingsData?.merchandise_font_primary_color"
                            (input)="getFilterData('search')"
                            (keyup.enter)="FinalSearch()"
                            placeholder="Search by Product">
                        <i class="fa fa-search" [ngStyle]="{'color': settingsData?.merchandise_font_primary_color}"></i>
                    </div>
                </div>

                <div class="col-6 d-flex align-items-center text-right justify-content-end">
                    <div class="d-inline-block">
                        <span class="dropdown relative">
                            <div mat-flat-button class=" btn btn-primary dropdown-toggle d-flex align-items-center"
                                id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false" [ngStyle]="{'background-color': settingsData?.merchandise_bg_primary_color , 'color': settingsData?.merchandise_font_primary_color}">
                                <i class="material-icons">sort</i>
                                <div class="d-inline-block ml-5 mr-15">
                                    <span *ngIf="!selectedValue" class="text-truncate d-inline-block mt-1">Sort</span>

                                    <span *ngIf="selectedValue"
                                        class="text-truncate d-inline-block mt-1">{{selectedValue}}</span>
                                </div>
                            </div>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" [ngStyle]="{'background-color': settingsData?.merchandise_bg_primary_color}" [style.--hover-bg]="settingsData?.merchandise_font_primary_color">
                                <span *ngFor="let sort of sortList">
                                    <a class="dropdown-item-m fs-13" 
                                    [style.--item-font]="settingsData?.merchandise_font_primary_color" 
                                    [style.--hover-font]="settingsData?.merchandise_bg_primary_color"
                                    (click)="sortbyfilter(sort.name)">
                                        {{sort.name}}
                                    </a>
                                </span>
                            </div>
                        </span>
                    </div>
                </div>

            </div>
        </div>

        <div class="d-flex active rigtcon" id="overall" [ngStyle]="{'background-color':settingsData?.merchandise_bg_main_color}">
            <div class="w-100 LeftSection">


                <div class="prod-Section">
                    <ng-container *ngFor="let brand of brandProductsList">
                        <!-- <ng-container *ngFor="let item of dumaarr"> -->
                        <div class="cards" [ngStyle]="{'background-color':settingsData?.merchandise_card_bg_color, 'color':settingsData?.merchandise_card_font_color}"
                            (click)="productOverview( brand._source.collection_id, brand._source.product_id, brand._source.organization_id, brand._source.network_group_id )">
                            <div class="borderColor">
                                <div class="imagediv"
                                    [ngStyle]="{'background-image':' url(' + brand._source.images+ ')','background-color':settingsData?.merchandise_bg_secondary_color}">
                                </div>
                            </div>
                            <div class="desc-con">
                                <div class="dec" matTooltipPosition="above" matTooltip="{{brand._source.title}}">
                                    <!-- {{brand._source.title}} -->
                                    {{brand._source.title | slice: 0:25}}
                                    {{brand._source.title.length > 25 ? "..." : ""}}
                                </div>
                                <p class="brandName mb-0" matTooltipPosition="above"
                                    matTooltip="{{brand._source.description}}">
                                    {{brand._source.description}}
                                </p>

                                <div class="darkText">
                                    <span>
                                        <!-- <img style="height:20px" src="../assets/logo-icon.svg"> -->
                                        <!-- <app-svg [icon]="'arevea-green-symbol'"></app-svg> -->
                                    </span>{{brand._source.price | currency:
                                    brand._source.currency}}<span class="lytText"></span>

                                </div>
                            </div>
                        </div>
                        <!-- </ng-container> -->
                    </ng-container>
                </div>
                <!-- <div *ngIf="found == brandProductsList.length && brandProductsList.length!=0 ">
                    <div class="d-flex align-items-center justify-content-center mt-25">
                        <span class="leftend"></span>
                        <span class="end">END</span>
                        <span class="rightend"></span>
                    </div>
                </div> -->
            </div>
        </div>
    </div>


</div>